module.exports = __webpack_public_path__ + "media/src/assets/Images/BlueTelephone-f8a62817a130c51405cf4fa8bf87fa55.svg";